import { FieldOptions, EasyTabField, EasyCardField, EasyAccordionField, EasyExpansionPanelField } from '../index';
import { EasyField } from '../baseClasses/easyField';
import { EasyContainer } from '../baseClasses/easyContainer';
import { EasyForm } from '../baseClasses/easyForm'

export class EasyStepperField extends EasyContainer {
    controlType = 'stepper';
    form: EasyForm

    constructor(form: EasyForm, options: FieldOptions<any> = {}) {
        super("", options, form, 'stepper');
        this.form = form;
    }

    addStepToStepperContainer(header: string, options: FieldOptions<any> = {}): EasyCardField {
        let container = new EasyCardField(header, options, this.form)
        this.addContainer(container);
        return container;
    }
}